import { html, css, LitElement } from 'lit';
import '@material/mwc-dialog/mwc-dialog.js';
import '@polymer/iron-image/iron-image.js';
import '@polymer/iron-icons/iron-icons.js';
import '@polymer/iron-icon/iron-icon.js';
import { GestureEventListeners } from '@polymer/polymer/lib/mixins/gesture-event-listeners.js';
import * as Gestures from '@polymer/polymer/lib/utils/gestures.js';

export class CbarPhotoPreview extends GestureEventListeners(LitElement) {
  static get styles() {
    return css`
      :host {
        display: block;
        color: var(--cbar-photo-preview-text-color, #000);
      }
      .wrapper {
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: row;
        width: 100%;
      }
      .overlay {
        width: 32px;
        z-index: 1;
        position: absolute;
        display: flex;
        align-items: center;
        top: 0;
        bottom: 0;
        background: black;
        opacity: 0.5;
        transition: 0.3s ease;
        cursor: pointer;
      }
      mwc-dialog {
        width: 100%;
        height: 100%;
        max-width: 896px;
        background: black;
        cursor: grab;
        transition: 0.3s ease;
      }
      iron-image {
        position: static;
      }
      iron-icon {
        width: 32px;
        height: 32px;
        color: white;
      }
      .overlay:hover {
        opacity: 0.8;
      }
      .overlay:hover icon-icon {
        opacity: 1;
      }
      .left-overlay {
        left: 0;
      }
      .right-overlay {
        right: 0;
      }
      .dragged {
        -ms-transform: translate(0, -100px); /* IE 9 */
        -webkit-transform: translate(0, -100px); /* Safari */
        transform: translate(0, -100px);
      }
      @media (max-width: 550px) {
        paper-dialog {
          margin: 0;
          max-width: unset;
          max-height: unset;
        }
      }
    `;
  }

  static get properties() {
    return {
      open: { type: Boolean },
      image: { type: String },
    };
  }

  constructor() {
    super();
    this.open = false;
    this.image = '';
    Gestures.addListener(this, 'track', this.handleTrack.bind(this));
  }

  get open() {
    return this._open;
  }

  get image() {
    return this._image;
  }

  get imageDiv() {
    if (!this._imageDiv) {
      this._imageDiv = this.shadowRoot.querySelector('.displayed-image');
    }
    return this._imageDiv;
  }

  /**
   * getter to make sure the toggle function is easy to use
   * @return {Element | *}
   */
  get dialog() {
    if (!this._dialog) {
      this._dialog = this.shadowRoot.querySelector('mwc-dialog');
    }
    return this._dialog;
  }

  set image(image) {
    this._image = image;
    this.requestUpdate();
  }

  set open(open) {
    this._open = open;
    this.requestUpdate();
  }

  render() {
    return html`
      <mwc-dialog
        .hideActions
        ?open=${this.open}
        with-backdrop
        scroll-action="lock"
        @track=${this.handleTrack}
        @opened=${e => {
          this.handleOpenedChanged(e);
        }}
        @closed=${e => {
          this.handleOpenedChanged(e);
        }}
      >
        <div class="wrapper">
          <div
            class="left-overlay overlay"
            @click=${() => {
              this.handleNav('back');
            }}
          >
            <iron-icon icon="chevron-left"></iron-icon>
          </div>
          <iron-image
            class="displayed-image"
            src=${this.image}
            sizing="contain"
          ></iron-image>
          <div
            class="right-overlay overlay"
            @click=${() => {
              this.handleNav('forward');
            }}
          >
            <iron-icon icon="chevron-right"></iron-icon>
          </div>
        </div>
      </mwc-dialog>
    `;
  }

  /**
   * simple toggle function to allow of ease of use from the outside
   */
  toggle() {
    this.open = !this.open;
    this.__checkImageSizing();
  }

  __checkImageSizing() {
    if (this.open) {
      this.imageDiv.$.sizedImgDiv.style.backgroundColor = "black";
      this.imageDiv.style.height = `${window.innerHeight}px`;
      this.imageDiv.style.width = `${window.innerWidth}px`;
    }
  }

  handleOpenedChanged() {
    this.__checkImageSizing();
    this.open = this.dialog.open;
  }

  /**
   * Handles left or right navigation being called from the side navs
   * @param direction
   */
  handleNav(direction) {
    this.dispatchEvent(
      new CustomEvent(`navigate-${direction}`, {
        bubbles: true,
        composed: true,
      })
    );
  }

  handleTrack(event) {
    const details = event.detail;
    if (details.state === 'start') {
      this._verticalMovementStart = details.y;
    }

    if (details.state === 'track') {
      if (this._verticalMovementStart > details.y) {
        this.closing = true;
        this.dialog.classList.add('dragged');
      } else {
        this.closing = false;
        this.dialog.classList.remove('dragged');
      }
    }

    if (details.state === 'end') {
      this._verticalMovementEnd = details.y;

      requestAnimationFrame(() => {
        if (
          this._verticalMovementStart > this._verticalMovementEnd &&
          this.closing
        ) {
          this.dialog.close();
          this.dialog.classList.remove('dragged');
        }
      });
    }
  }
}
